function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @packageDocumentation
 * @internal
 */
import { safeGlobal } from '@amplitude/experiment-core';
import unfetch from 'unfetch';
const fetch = safeGlobal.fetch || unfetch;
/*
 * Copied from:
 * https://github.com/github/fetch/issues/175#issuecomment-284787564
 */

const timeout = (promise, timeoutMillis) => {
  // Don't timeout if timeout is null or invalid
  if (timeoutMillis == null || timeoutMillis <= 0) {
    return promise;
  }

  return new Promise(function (resolve, reject) {
    safeGlobal.setTimeout(function () {
      reject(Error('Request timeout after ' + timeoutMillis + ' milliseconds'));
    }, timeoutMillis);
    promise.then(resolve, reject);
  });
};

const _request = (requestUrl, method, headers, data, timeoutMillis) => {
  const call = async () => {
    const response = await fetch(requestUrl, {
      method: method,
      headers: headers,
      body: data
    });
    const simpleResponse = {
      status: response.status,
      body: await response.text()
    };
    return simpleResponse;
  };

  return timeout(call(), timeoutMillis);
};
/**
 * Wrap the exposed HttpClient in a CoreClient implementation to work with
 * FlagsApi and EvaluationApi.
 */


export class WrapperClient {
  constructor(client) {
    _defineProperty(this, "client", void 0);

    this.client = client;
  }

  async request(request) {
    return await this.client.request(request.requestUrl, request.method, request.headers, null, request.timeoutMillis);
  }

}
export const FetchHttpClient = {
  request: _request
};
//# sourceMappingURL=http.js.map